<template>
  <div id="bathroom-count-numbers">
    <CountButton
      v-for="count in counts"
      :key="count"
      :count="count"
      :selected="selected === count"
      @click="selectCount(count)"
    />
  </div>
</template>
<script>
import CountButton from "./CountButton.vue";
export default {
  data() {
    return {
      selected: undefined,
      counts: ["1", "2", "3+"],
    };
  },
  computed: {},
  methods: {
    selectCount(count) {
      this.selected = count;
      this.$emit("bathroom-input", count);
    },
  },
  components: {
    CountButton,
  },
  emits: { "bathroom-input": null },
};
</script>
<style scoped>
#bathroom-count-numbers {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
</style>